var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventCoverButtonRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5625 7C13.8041 7 14 6.80412 14 6.5625C14 6.32088 13.8041 6.125 13.5625 6.125M13.5625 7C13.3209 7 13.125 6.80412 13.125 6.5625C13.125 6.32088 13.3209 6.125 13.5625 6.125M13.5625 7V6.125",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 1.75L19.25 19.25",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1372 18.6372C14.0164 18.8125 12.539 18.8125 10.5 18.8125C6.79899 18.8125 4.94847 18.8125 3.72116 17.7643C3.54688 17.6154 3.38457 17.4531 3.23572 17.2788C2.1875 16.0515 2.1875 14.201 2.1875 10.5C2.1875 8.461 2.1875 6.98367 2.36279 5.86279M17.5311 17.5311C17.6121 17.4501 17.6899 17.366 17.7643 17.2788C18.8125 16.0515 18.8125 14.201 18.8125 10.5C18.8125 6.79899 18.8125 4.94847 17.7643 3.72116C17.6154 3.54688 17.4531 3.38457 17.2788 3.23572C16.0515 2.1875 14.201 2.1875 10.5 2.1875C6.79899 2.1875 4.94847 2.1875 3.72116 3.23572C3.63402 3.31015 3.54987 3.38794 3.46891 3.46891",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.625 13.9997L6.56282 10.0625M18.375 13.9997L16.214 11.8387C15.917 11.5416 15.5139 11.3747 15.0938 11.3747C14.6736 11.3747 14.2705 11.5416 13.9735 11.8387L12.9062 12.9059",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventCoverButtonRemove);
export default __webpack_public_path__ + "static/media/event_cover_button_remove.11538b91359a83228855eaffba38adfe.svg";
export { ForwardRef as ReactComponent };